import styled from 'styled-components';
import Card from './Card';
import { BREAKPOINTS } from '../../styles/variables';

const Cards = ({ data }) => (
  <CardsWr>
    {data.cards.data.map((card, index) => (
      <Card key={`${index}-card`} data={card.attributes} />
    ))}
  </CardsWr>
);

const CardsWr = styled.section`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  @media ${BREAKPOINTS.laptop} {
    gap: 1.39vw;
  }

  @media ${BREAKPOINTS.mobile} {
    grid-template-columns: repeat(1, 1fr);
    gap: 3.33vw;
  }
`;

export default Cards;
